import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { DataRequest } from "../../models/data-request.model";

import { dataRequestDetailQuery } from "./data-request.gql";

interface DataRequestDetailResponse {
  dataRequest: DataRequest;
}

export interface UseGetDataRequestProps {
  id?: string;
  workspaceId?: string;
  enabled?: boolean;
}

export const useGetDataRequestQuery = ({ id, workspaceId, enabled = true }: UseGetDataRequestProps) => {
  const queryResult = useQuery({
    queryKey: [...queryKeys.dataRequests.detail(id ?? ""), workspaceId ?? ""],
    queryFn: async () => {
      if (!id || !workspaceId) {
        throw new Error("Data Request ID and Workspace ID are required");
      }

      const client = createOperationClient("DataRequestDetail");
      const data = await client.request<DataRequestDetailResponse>(dataRequestDetailQuery, { id, workspaceId });

      return data.dataRequest;
    },
    enabled: enabled && !!id && !!workspaceId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    dataRequest: queryResult.data ?? null,
  };
};
